import React from "react";
import { Outlet } from "react-router-dom";
import HeaderComponent from "./Header";
import FooterComponent from "./Footer";
import { useScrollToTop } from "../../../hooks/useScrollToTop";

export const AppLayout: React.FC = () => {
  useScrollToTop();

  return (
    <div className="flex min-h-screen flex-col bg-white font-poppins text-ink dark:bg-slate-950 dark:text-slate-100">
      <HeaderComponent />
      <main className="w-full flex-1">
        <Outlet />
      </main>
      <FooterComponent />
    </div>
  );
};

export default AppLayout;
